<template>
  <font-awesome-icon
    icon="question-circle"
    size="lg"
    class="icon"
    @click.stop="editEventQuizset()"/>
</template>

<script>
export default {
  props: {
    event: {
      required: true,
      type: Object
    }
  },

  methods: {
    editEventQuizset: function () {
      this.$router.push({
        name: 'event-closed-quizset',
        params: { id: this.event.id }
      })
    }
  }
}
</script>

